import React from 'react';
import { Helmet } from 'react-helmet-async';

const DefaultHelmet = () => {
  return (
    <Helmet defaultTitle="Greether | Travel Safer" titleTemplate="%s">
      <meta
        name="description"
        content="Greether is the platform that helps women travel safer by connecting them to verified local female Greeters around the world."
      />
      <meta
        name="keywords"
        content="travel, women travel, safe travel, female travel, local guides"
      />
    </Helmet>
  );
};

export default DefaultHelmet;
